<template>
    <span class="LabelBadge" :class="[`LabelBadge--${color}`, `LabelBadge--${size}`, `LabelBadge--${variant}`]">
        <slot />
    </span>
</template>

<style lang="scss">
.LabelBadge {
    display: inline-flex;
    align-items: center;
    border-radius: 6px;
    font-weight: var(--text-badge-weight);
    white-space: nowrap;
    border: 1px solid transparent;

    &--lg {
        padding: var(--control-size-lg-padding);
        font-size: var(--control-size-lg-font-size);
        line-height: var(--control-size-lg-line-height);
    }

    &--default {
        padding: var(--control-size-default-padding);
        font-size: var(--control-size-default-font-size);
        line-height: var(--control-size-default-line-height);
    }

    &--sm {
        padding: var(--control-size-sm-padding);
        font-size: var(--control-size-sm-font-size);
        line-height: var(--control-size-sm-line-height);
    }

    &--xs {
        padding: var(--control-size-xs-padding);
        font-size: var(--control-size-xs-font-size);
        line-height: var(--control-size-xs-line-height);
    }

    &--info {
        background-color: var(--eidQualityBlack-10);
        color: var(--eidSecureBlue-75);
    }

    &--success {
        color: var(--eidTrustGreen);
        background-color: var(--eidTrustGreen-10);
    }

    &--warning {
        color: var(--eidWarningYellow);
        background-color: var(--eidWarningYellow-10);
    }

    &--danger {
        color: var(--eidDangerRed-75);
        background-color: var(--eidDangerRed-10);
    }

    &--gradient {
        background: linear-gradient(var(--eidSafetyBlue), var(--eidTrustGreen));
        color: var(--eidWhite);
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { ComponentSize } from '@evidentid/tprm-portal-lib/models/common';

    export type LabelBadgeColor = 'info' | 'success' | 'warning' | 'danger';
    export type LabelBadgeVariant = 'fill' | 'gradient';

    export default defineComponent({
        name: 'LabelBadge',

        props: {
            color: {
                type: String as PropType<LabelBadgeColor>,
                default: 'info',
                validator: (value: string) =>
                    [ 'info', 'success', 'warning', 'danger' ].includes(value),
            },
            size: {
                type: String as PropType<ComponentSize>,
                default: 'default',
            },
            variant: {
                type: String as PropType<LabelBadgeVariant>,
                default: 'fill',
                validator: (value: string) => [ 'fill', 'gradient' ].includes(value),
            },
        },
    });
</script>
